import dayjs from "dayjs"
import DynamicFormTaskTypes from "src/pages/dynamic_forms/Types/DynamicFormTaskTypes"
import hashTable from "./hashTable"

const storageSize = 2500
const ht = new hashTable(storageSize)
const timeFormat = "MM/DD/YY h:mm a"
const date = new Date()
const timeZoneOffset = -date.getTimezoneOffset()

const taskManagerUtils = {
    reference: null,
    buildHashTable: (tasks: Array<DynamicFormTaskTypes>) => {
        ht.purgeTable(false)
        for (let i = 0; i < tasks.length; i++) {
            const name = taskManagerUtils.getTextFromReference(tasks[i].CustomFormId, "forms")
            const id = tasks[i].DynamicFormWorkFlowId
            ht.addItem([`${id}`, i, ht.hash(`${id}`, storageSize), name, tasks[i]])
        }
        const storage = ht.getStorage()
        return storage
    },
    lookupItem: (hashKey: string) => {
        return ht.lookupItem(hashKey)
    },
    getTimeDiscrepancy: (a: string, b: string, timeZoneOffset: number) => {
        const due = dayjs(a).utcOffset(timeZoneOffset)
        const completed = dayjs(b).utcOffset(timeZoneOffset)
        const difference = due.diff(completed)
        return difference
    },
    sort: (ids: Array<number>, sortMap: { direction: "asc" | "desc", type: "date" | "text" | "number", key: string }) => {
        let temp = []
        let sorted = []
        for (let i = 0; i < ids.length; i++) {
            const item = taskManagerUtils.lookupItem(`${ids[i]}`)
            temp.push(
                {
                    ...item[4],
                    ...{ Name: item[3] },
                    //@ts-ignore
                    ...{ Punctuality: `${taskManagerUtils.getTimeDiscrepancy(dayjs((item[4].DueDateUTC)).utc("z").utcOffset(timeZoneOffset).format(timeFormat), dayjs((item[4].CompletedDateUTC)).utc("z").utcOffset(timeZoneOffset).format(timeFormat), timeZoneOffset)}` }
                }
            )
        }
        if (sortMap.type === "date") {
            temp.sort(function (a, b) {
                //@ts-ignore
                const result = sortMap.direction === "asc" ? new Date(b[sortMap.key]) - new Date(a[sortMap.key]) : new Date(a[sortMap.key]) - new Date(b[sortMap.key])
                return result
            })
        } else if (sortMap.type === "text") {
            sortMap.direction === "asc"
                ? temp.sort((a, b) => a[sortMap.key].localeCompare(b[sortMap.key], 'en', { 'sensitivity': 'base' }))
                : temp.sort((a, b) => b[sortMap.key].localeCompare(a[sortMap.key], 'en', { 'sensitivity': 'base' }))
        } else {
            sortMap.direction === "asc"
                ? temp.sort((a, b) => { return a[sortMap.key] - b[sortMap.key]; })
                : temp.sort((a, b) => { return b[sortMap.key] - a[sortMap.key]; })
        }
        for (let i = 0; i < temp.length; i++) {
            sorted.push(temp[i].DynamicFormWorkFlowId)
        }
        temp = []
        return sorted
    },
    getTextFromReference: (id: number, key: string) => {
        const reference = taskManagerUtils.reference
        //@ts-ignore
        const formType = reference[key].filter(obj => {
            return obj.id === id
        })[0]
        return formType ? formType.text : "*NA*"
    }
}

export default taskManagerUtils